import { AdditionalItemForPrescriptionReleaseStruct } from "../../structs/pharmacy/additional-item-for-prescription-release.struct";
import { AdditionalMedicineForPrescriptionReleaseStruct } from "../../structs/pharmacy/additional-medicine-for-prescription-release.struct";
import { KitItemIdAndAmountToUseStruct } from "../../structs/pharmacy/kit-item-id-and-amount-to-use.struct";

export class LiberatePrescriptionRequest {
    public listIdItemAmount: KitItemIdAndAmountToUseStruct[];
    public listAdditionalItemForPrescriptionRelease: AdditionalItemForPrescriptionReleaseStruct[] = [];
    public listAdditionalMedicineForPrescriptionRelease: AdditionalMedicineForPrescriptionReleaseStruct[] = [];

    public medicineName: string;
    public administrationTypeName: string;
    public patientName: string;
    public motherName: string;
    public dilutionName: string;

    public birthDate: Date;

    public listIdKit: number[];
    public idStorage: number;
    public idMedicine: number;
    public idLocation: number;
    public quantity: number;
    public idStatusPrescription: number;
    public idPresentationType?: number;
    public idMedicalPrescription: number;
    public amountRemaining?: number;
    public idEpisode: number;
    public idPrescriptionMedicine: number;
    public idUserPharmacy?: number;
    public idUserNurse?: number;
    public idSector?: number;
    //multiprofissional
    public idPrescriptionSolutionMedicine: number;
}